import React from 'react';
import './caro.css';
import video from '../img/video.mp4';

const Carousal = () => {
  return (
    <div className="carousal-container">
      {/* Background Video */}
      <video className="background-video" autoPlay loop muted>
        <source src={video} type="video/mp4" />

      </video>

      {/* Content Section */}
      <div className="carousal-content">
        <h1>Dr. Manish Khattar
          - Your Best Choice for

          Urological Health</h1>
        <p>Trust Dr. Manish Khattar  to provide the

          personalized treatment you deserve. </p>
        <button className="explore-btn">Book Appointment </button>
      </div>
    </div>
  );
};

export default Carousal;
